import { render, staticRenderFns } from "./myChannels.vue?vue&type=template&id=1a1de358&scoped=true&lang=pug&"
import script from "./myChannels.vue?vue&type=script&lang=js&"
export * from "./myChannels.vue?vue&type=script&lang=js&"
import style0 from "./myChannels.vue?vue&type=style&index=0&id=1a1de358&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a1de358",
  null
  
)

export default component.exports